import { ITabletData } from "api/types";
import TabletInfoAnnotation from "components/common/TabletInfoAnnotation/TabletInfoAnnotation";
import { TabletDataContext } from "components/Gates/TabletDataGate";
import { History } from "history";
import * as React from "react";
import { Routes } from "router";
import WelcomeBoard from "screens/Onboarding/WelcomeBoard/WelcomeBoard";
import version from "version";
interface IProps {
  tabletData?: ITabletData;
  history: History;
}

const PointOfSale = ({ tabletData, history }: IProps) => {
  return (
    <>
      <WelcomeBoard history={history} />
      <TabletInfoAnnotation version={version} tabletData={tabletData} />
    </>
  );
};

export default (props: IProps) => (
  <TabletDataContext.Consumer>
    {tabletData =>
      tabletData && <PointOfSale tabletData={tabletData} {...props} />
    }
  </TabletDataContext.Consumer>
);



// WEBPACK FOOTER //
// ./src/screens/PointOfSale/index.tsx